<template>
  <div class="col-lg-4">
    <div class="data-item-title">
      <span v-if="!loading">{{title}}</span>
      <SkeletonBox width="40%" v-if="loading" />
    </div>
    <div :class="['mb-3', 'data-item-content', textWrap ? '' : 'text-truncate']">
      <slot v-if="!loading" />
      <SkeletonBox width="100%" v-if="loading" />
      <span v-if="title && !hasSlotContent && !loading">-</span>
    </div>
  </div>
</template>

<style scoped>
.data-item-title {
  color: #909090;
  position: relative;
}
.theme-dark .data-item-title {
  color: #c7c7c7;
}

.data-item-content {
  color: #676a6c;
  font-weight: 600;
  position: relative;
}
.theme-dark .data-item-content {
  color: rgb(122, 125, 127);
}
</style>

<script>
export default {
  name: 'DataItem',
  props: {
    title: String,
    textWrap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasSlotContent: false,
    }
  },
  computed: {
    loading() {     
      var loadingComponent = this.findLoadingParent(this.$parent)
      if(loadingComponent)
        return loadingComponent.$props.loading

      return false
    }
  },
  methods: {
    checkForSlotContent() {
      let checkForContent = (hasContent, node) => {
        return hasContent || node.tag || (node.text && node.text.trim())
      }
      return this.$slots.default && this.$slots.default.reduce(checkForContent, false)
    },
    // Recursively find the parent 'ContentBox' or 'TabbedBox' components for the data item
    // Checks the parent's loading prop
    findLoadingParent(comp) {
      if(comp == null)
        return null
      if(comp.$options.name == 'ContentBox' || comp.$options.name == 'TabbedBox')
        return comp

      return this.findLoadingParent(comp.$parent)
    }
  },
  beforeUpdate() {
    this.hasSlotContent = this.checkForSlotContent()
  },
  created() {
    this.hasSlotContent = this.checkForSlotContent()    
  }
}
</script>
